<template>
  <div class="space-y-4">
    <div class="bg-gray-50 dark:bg-gray-900 rounded-xl p-4 border-gray-100 dark:border-gray-700/50">
      <div class="flex items-center justify-between">
        <span class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ t('app.views.cashRegister.expectedFinalBalance') }}
        </span>
        <span class="font-semibold text-gray-900 dark:text-gray-100">
          {{ formatCurrency(expectedBalance) }}
        </span>
      </div>
    </div>
    <div class="bg-gray-50 dark:bg-gray-900 rounded-xl p-4 border-gray-100 dark:border-gray-700/50">
      <div class="flex items-center justify-between">
        <span class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ t('app.views.cashRegister.actualFinalBalance') }}
        </span>
        <span class="font-semibold text-gray-900 dark:text-gray-100">
          {{ formatCurrency(actualBalance) }}
        </span>
      </div>
    </div>
    <div class="bg-gray-50 dark:bg-gray-900 rounded-xl p-4 border-gray-100 dark:border-gray-700/50">
      <div class="flex items-center justify-between">
        <div>
          <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">
            {{ t('app.views.cashRegister.difference') }}
          </span>
          <p
            class="text-xs mt-1"
            :class="differenceTextClass"
          >
            {{ differenceLabel }}
          </p>
        </div>
        <div class="text-right">
          <span
            class="text-xl font-bold"
            :class="differenceClass"
          >
            {{ formattedDifference }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { formatCurrency } from '@/utils/priceHelpers';

interface Props {
  expectedBalance: number;
  actualBalance: number;
  differenceClass: string;
  differenceTextClass: string;
  differenceLabel: string;
  formattedDifference: string;
}

defineProps<Props>();

const { t } = useI18n();
</script>
